import React, { useState, useEffect } from "react";
import "../../styles/FunVideo.scss";
import videoFile from "../../components/assets/video/fun.mov";

const Video: React.FC = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showModal]);

  return (
    <section className="fun-video-section">
      <div className="fun-video-wrapper" onClick={() => setShowModal(true)}>
        <video
          className="fun-bg-video"
          src={videoFile}
          autoPlay
          loop
          muted
          playsInline
        ></video>

        <div className="fun-video-overlay"></div>

        <div className="fun-video-text">
          <div className="fun-text-top">
            Why You'll Love It Here
          </div>

          <div className="fun-text-bottom">
            Beyond its breathtaking scenery, the Philippines is defined by its people — warm, 
            genuine, and always ready to make you feel at home. From bustling cities to serene 
            islands, you’ll discover that the real heart of the Philippines isn’t just in its places — it’s 
            in its people.
          </div>
        </div>
      </div>


      {showModal && (
        <div className="fun-video-modal">
          <div className="fun-modal-overlay" onClick={() => setShowModal(false)} />

          <div className="fun-modal-content">
            <button
              className="fun-close-btn"
              onClick={() => setShowModal(false)}
            >
              ✕
            </button>

            <video src={videoFile} controls autoPlay />
          </div>
        </div>
      )}
    </section>
  );
};

export default Video;
